import { ArgsType, Field } from '@nestjs/graphql'

@ArgsType()
export class BaseAddPictureDto {
  @Field()
  id!: string

  @Field()
  fileName?: string
}
